import type { IconSvgObject } from './types';

const Quran01Icon: IconSvgObject = [
  ["path", { d: "M11.9991 12.5L20 6.5L17.6471 3.5L11.9991 8L5.88235 3.5L4 6.5L11.9991 12.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 8.5L6 20.5V16M2 8.5L18 20.5V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Quran01Icon;
